exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".video-list-item {\n  display: flex;\n  padding: 10px;\n  height: 80px;\n  cursor: pointer;\n  transition: .3s ease;\n  border-bottom: 1px solid #666666;\n  border-top: 1px solid white;\n  animation: show .5s ease-in; }\n  .video-list-item:nth-child(2) {\n    animation: show .7s ease-in; }\n  .video-list-item:nth-child(3) {\n    animation: show 1s ease-in; }\n  .video-list-item:nth-child(4) {\n    animation: show 1.2s ease-in; }\n  .video-list-item:nth-child(5) {\n    animation: show 1.3s ease-in; }\n  .video-list-item:first-child {\n    border-top: none; }\n  .video-list-item:hover {\n    background: rgba(255, 255, 255, 0.5); }\n    .video-list-item:hover img {\n      box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.9); }\n  .video-list-item h4 {\n    margin: 0 0 0 10px;\n    font-size: 13px; }\n\n@keyframes show {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/VideoListItem.scss
// module id = 456
// module chunks = 0